import type { SelectorType } from '@/config/shared/selector';

import type { ConversionEventType } from '../../contracts';

const DATA_TRACK_EVENT_MAP: Record<string, ConversionEventType> = {
  purchase: 'PURCHASE',
  lead: 'LEAD',
  add_to_cart: 'ADD_TO_CART',
  addtocart: 'ADD_TO_CART',
  remove_from_cart: 'REMOVE_FROM_CART',
  removefromcart: 'REMOVE_FROM_CART',
  initiate_checkout: 'INITIATE_CHECKOUT',
  initiatecheckout: 'INITIATE_CHECKOUT',
  checkout: 'INITIATE_CHECKOUT',
  add_payment_info: 'ADD_PAYMENT_INFO',
  addpaymentinfo: 'ADD_PAYMENT_INFO',
  view_content: 'VIEW_CONTENT',
  viewcontent: 'VIEW_CONTENT',
  search: 'SEARCH',
};

export function resolveDataTrackEvent(
  value: string
): ConversionEventType | null {
  const normalized = value.trim().toLowerCase().replace(/\s+/g, '_');
  return DATA_TRACK_EVENT_MAP[normalized] ?? null;
}

export function buildSelector(selector: string): string {
  if (
    selector.startsWith('[') ||
    selector.startsWith('.') ||
    selector.startsWith('#')
  ) {
    return selector;
  }
  return `[data-track="${selector}"]`;
}

export function buildSelectorFromConfig(
  selector: string,
  selectorType: SelectorType = 'css'
): string {
  if (
    selector.startsWith('[') ||
    selector.startsWith('.') ||
    selector.startsWith('#')
  ) {
    return selector;
  }

  switch (selectorType) {
    case 'id':
      return selector.startsWith('#') ? selector : `#${selector}`;
    case 'class':
      return selector.startsWith('.') ? selector : `.${selector}`;
    case 'css':
      return selector;
    case 'text':
      // Text selectors are resolved by SelectorResolver (Etapa 12B).
      // Do not wrap as data-track — that would be incorrect.
      return selector;
    case 'attribute':
      return buildSelector(selector);
  }
}
